import React from 'react';
import { Shield, Clock, Users } from 'lucide-react';
import { performanceGuarantee } from '../../data/mock';

const PerformanceGuarantee = () => {
  const icons = [Shield, Clock, Users];

  return (
    <section id="guarantee" className="py-16 lg:py-20 bg-gradient-to-b from-stone-50 to-amber-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-amber-100/20 to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-amber-800/80 text-base tracking-[0.2em] uppercase mb-4">
            {performanceGuarantee.titleEn}
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            {performanceGuarantee.title}
          </h2>
          <div className="w-20 h-px bg-amber-700/40 mx-auto mb-8" />
          <p className="text-lg text-stone-600 max-w-2xl mx-auto font-light leading-relaxed">
            {performanceGuarantee.description}
          </p>
        </div>

        {/* Highlights */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {performanceGuarantee.highlights.map((highlight, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 text-center shadow-sm card-hover border border-stone-100 group card-gradient-accent"
              >
                <div className="w-12 h-12 mx-auto mb-6 rounded-full bg-amber-100/50 flex items-center justify-center group-hover:bg-amber-100 transition-colors">
                  <Icon className="w-5 h-5 text-amber-800" />
                </div>
                <div className="text-5xl font-light text-stone-800 mb-2">
                  {highlight.stat}
                </div>
                <div className="text-amber-800 text-base tracking-wider uppercase mb-3">
                  {highlight.label}
                </div>
                <p className="text-stone-500 text-base font-light">
                  {highlight.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Trust statement */}
        <div className="mt-16 text-center">
          <div className="relative inline-block">
            {/* Main container - minimal and professional */}
            <div className="relative bg-white rounded-lg px-10 py-6 shadow-sm border border-stone-200 overflow-hidden group hover:shadow-md transition-shadow duration-500">
              {/* Subtle bottom accent line with gentle animation */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-amber-600/60 to-transparent" />
              
              {/* Main text */}
              <p className="text-xl md:text-2xl font-light text-stone-700 tracking-wide">
                オーナー様の成功が、私たちの成功です
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerformanceGuarantee;
